import React from 'react';

const toneClasses = {
  light: 'bg-surface text-ink-900',
  dim: 'bg-surface-dim text-ink-900',
  dark: 'bg-surface-dark text-white',
};

export function SectionShell({ id, tone = 'light', className = '', children }) {
  return (
    <section
      id={id}
      className={`w-full py-10 md:py-[120px] px-6 md:px-[120px] ${toneClasses[tone] || toneClasses.light} ${className}`}
    >
      <div className="mx-auto w-full flex flex-col items-center gap-12 md:gap-16">{children}</div>
    </section>
  );
}
